exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .gupWTp2eM3cUl7M5VSOh_{margin:10px 0}", ""]);

// exports
exports.locals = {
	"feedbackDialogCheckbox": "gupWTp2eM3cUl7M5VSOh_"
};